<template>
    <AdmPanel width="500px" align="center" :loading="loader.detail">
        <h2 slot="header_title">{{ tracker.isNew ? "新建":"编辑" }}公司详情</h2>
        <iv-form :model="sources.detail" label-position="top" :ref="FORM_NAME" :rules="options.validation">
            <iv-form-item label="证券代码：" prop="stockCode">
              <iv-row :gutter="24">
                <iv-col span="24">
                  <iv-input v-model="sources.detail.stockCode" :disabled="!tracker.isNew" :placeholder="options.placeholder.stockCode" limiter></iv-input>
                </iv-col>
              </iv-row>
            </iv-form-item>
            <iv-form-item label="公司简称：" prop="abbreviation">
              <iv-row :gutter="24">
                <iv-col span="24">
                  <iv-input v-model="sources.detail.abbreviation" :placeholder="options.placeholder.abbreviation" limiter></iv-input>
                </iv-col>
              </iv-row>
            </iv-form-item>
            <iv-form-item label="公司全称：" prop="companyName">
              <iv-row :gutter="24">
                <iv-col span="24">
                  <iv-input v-model="sources.detail.companyName" :placeholder="options.placeholder.companyName" limiter></iv-input>
                </iv-col>
              </iv-row>
            </iv-form-item>
            <iv-form-item label="上市类型：" prop="companyType">
                <iv-row :gutter="24" type="flex" justify="start">
                    <iv-col span="8">
                        <iv-select v-model="sources.detail.companyType" :placeholder="options.placeholder.companyType">
                            <iv-option v-for="item in options.companyType"
                                       :key="item.id" :value="item.id">
                                {{ item.title }}
                            </iv-option>
                        </iv-select>
                    </iv-col>
                </iv-row>
            </iv-form-item>
            <iv-form-item label="公司状态：" prop="isDelete">
                <iv-row :gutter="24" type="flex" justify="start">
                    <iv-col span="8">
                        <iv-select v-model="sources.detail.isDelete" :placeholder="options.placeholder.isDelete">
                            <iv-option v-for="item in options.isDelete"
                                       :key="item.id" :value="item.id">
                                {{ item.title }}
                            </iv-option>
                        </iv-select>
                    </iv-col>
                </iv-row>
            </iv-form-item>
            <iv-form-item label="所属行业：" prop="industryId">
                <iv-row :gutter="24" type="flex" justify="start">
                    <iv-col span="15">
                      <!-- <template v-if="isListed">
                        <iv-select v-model="sources.detail.industryId">
                            <iv-option v-for="industry in options.industries" :key="industry.id" :value="industry.id">
                                {{ industry.name }}
                            </iv-option>
                        </iv-select>
                      </template> -->
                       <iv-checkbox-group v-model="sources.detail.industryIdList" @on-change="industrySelect">
                           <iv-checkbox style="margin:0 10px" v-for="industry in options.industries" :key="industry.id" :label="industry.id">
                             {{ industry.name }}</iv-checkbox>
                       </iv-checkbox-group>
                    </iv-col>
                </iv-row>
            </iv-form-item>
        </iv-form>
        <div slot="footer">
            <p>备注：公司未上市股票代码不填</p>
            <span class="adm-buttons pull-right">
                <iv-button @click="$$back({name:isListed?'listedCompany':'company'})">取消</iv-button>
                <iv-button type="primary" @click="save">保存</iv-button>
            </span>
        </div>
    </AdmPanel>
</template>

<script>
    import CarbonCompanyModel from "@/models/CarbonCompanyModel";
    import CarbonIndustryModel from "@/models/CarbonIndustryModel";
    import LoaderMixin from "@/mixins/Loader.mixin";
    import DetailMixin from "@/mixins/Detail.mixin";
    import ModelMixin from "@/mixins/Model.mixin";
    import StatusMixin from "@/mixins/Status.mixin";
    import contact from "@/utils/contact";
    import { companyType, isDelete } from "@/configs/options.conf"

    const COMPANY = CarbonCompanyModel.ModelName;
    const INDUSTRY = CarbonIndustryModel.ModelName;
    const FORM_NAME = `${COMPANY}Form`;
    const options = {
        companyType,
        isDelete,
    }
    export default {
        name: "company_detail",
        mixins: [
            LoaderMixin(COMPANY),
            ModelMixin({
                contact,
                models:[
                    CarbonCompanyModel, CarbonIndustryModel
                ]
            }),
            DetailMixin({
                model: COMPANY,
                form: FORM_NAME,
                schema(data){
                    return data
                }
            })
        ],
        data() {
            return {
                COMPANY,
                FORM_NAME,
                options: {
                    ...options,
                    industries: [],
                    validation : CarbonCompanyModel.validation(''),
                    placeholder: {
                        abbreviation: '请输入公司简称',
                        stockCode: '请输入股票代码',
                        companyName: '请输入公司全称',
                        companyType: '请选择上市类型',
                        industryIdList: '请选择公司所在行业',
                        isDelete: '请选择公司状态',
                    },
                },
                sources: {
                    detail: {}
                },
            }
        },
        async mounted() {
            //加载行业
            this.options.industries = await this.refreshIndustries();
        },
        beforeRouteUpdate(to, from, next) {
            this.$nextTick(async () => {
                if (this.options.industries.length == 0) {
                    this.options.industries = await this.refreshIndustries();
                }
            })
        },

        methods: {
            async refreshIndustries(query) {
                const industry = await this.$$fetch(INDUSTRY, { ...query });
                if (industry) return industry.data.map(item => ({ ...item, name: item.industry, title: item.industry }));
            },
            save(){
                this
                    .$$saveDetail()
                    .then((res)=>{
                      if(res.request&&res.request.status == 500) return;
                      if([400,409].indexOf(res.code) > -1 ) this.$$error(new Error(err.response.data.msg), 5)
                        // else this.$$back({ name: COMPANY , query: { ...this.$route.query, ordering: '-updateTime'}})
                      else{
                        this.$$back({ name: 'carbon_company'})
                        window.polling.runTask('refreshCarbonCompany')
                      }
                    });
            },
            destroy(){
                this
                    .$$destroyDetail()
                    .then(()=>this.$$back({ name: COMPANY }));
            },
            $$onRefreshDetail(data){
                if(data.industryId)data.industryIdList = [data.industryId]
                else data.industryList.map(item=>data.industryIdList.push(item.industryId))
                data.id = data.stockCode
              return data;
            },
            async $$refreshDetail(query) {
                if (query && query.stockCode) {
                    this._continue = true;
                    const result = await this.$$active(COMPANY, 'find', { ...query });
                    const detail = !!result.data.length ? result.data[0] : {}
                    this.tracker.isNew = false;
                    this.sources.detail = await this.$$onRefreshDetail(detail);
                    this.$nextTick(() => {
                        this._continue = false;
                    });
                }
            },
            industrySelect(item){
                if (this.sources.detail.industryIdList.length > 1) {
                    // 如果选择了多个，只保留最后一个
                    this.sources.detail.industryIdList = [this.sources.detail.industryIdList[this.sources.detail.industryIdList.length - 1]]
                    this.sources.detail.industryId = this.sources.detail.industryIdList[0]
                }
            }
        },
        computed: {
          isListed(){
            return this.$route.meta.permissions.hasOwnProperty('listedCompany')
          }
        }
    }
</script>

<style scoped>
</style>
